import {
  DndContext,
  useSensor,
  useSensors,
  MouseSensor,
  TouchSensor,
} from "@dnd-kit/core";
import React, { useEffect, useRef, useState } from "react";
import MakeBusyOrFreeTable from "./ReservationTablesSubComponents/MakeBusyOrFreeTable";

import { useSelector } from "react-redux";

import ResizeObserver from "resize-observer-polyfill";

import { Draggable } from "./ReservationTablesSubComponents/Draggable";
import { Droppable } from "./ReservationTablesSubComponents/Droppable";
import "./index.css";

const ReservationTables = ({ backgroundImage }) => {
  const [clickedTable, setClickedTable] = useState();
  const { tables } = useSelector((state) => state.restaurantSchemaReducer);

  const containerRef = useRef(null);
  const [containerSize, setContainerSize] = useState({
    width: 1300,
    height: 650,
  });

  useEffect(() => {
    const handleResize = (entries) => {
      for (let entry of entries) {
        if (entry.target === containerRef.current) {
          const { width, height } = entry.contentRect;
          setContainerSize({ width, height });
        }
      }
    };

    const resizeObserver = new ResizeObserver(handleResize);

    const currentContainer = containerRef.current;
    if (currentContainer) {
      resizeObserver.observe(currentContainer);
    }

    return () => {
      if (currentContainer) {
        resizeObserver.unobserve(currentContainer);
      }
    };
  }, []);

  const scaleFactor = Math.min(
    containerSize.width / 1300,
    containerSize.height / 650
  );

  const elementHeight = 70 * scaleFactor;

  const sensors = useSensors(
    useSensor(MouseSensor, {
      activationConstraint: {
        distance: 8,
      },
    }),
    useSensor(TouchSensor, {
      activationConstraint: {
        delay: 200,
        tolerance: 6,
      },
    })
  );

  const onTableClick = (id) => {
    setClickedTable(tables.filter((table) => table.touchSaleTableId === id));
  };

  return (
    <>
      <MakeBusyOrFreeTable
        clickedTable={clickedTable}
        setClickedTable={setClickedTable}
      />
      <div className="reservations-content-container">
        <DndContext sensors={sensors}>
          <Droppable ref={containerRef} backgroundImage={backgroundImage}>
            {tables?.map((table) => (
              <Draggable
                key={table.tableName}
                id={table.touchSaleTableId}
                tableName={table.tableName}
                position={{
                  x: table.x * scaleFactor,
                  y: table.y * scaleFactor,
                }}
                direction={table.direction}
                src={table.src}
                alt={`Draggable ${table.tableName}`}
                height={`${elementHeight}px`}
                aspectRatio={table.aspectRatio}
                nextReservation={table.nextReservation}
                isBusy={table.busy}
                tableOpenDurationInMinutes={table.tableOpenDurationInMinutes}
                onTableClick={onTableClick}
              />
            ))}
          </Droppable>
        </DndContext>
      </div>
    </>
  );
};

export default ReservationTables;
